<template>
	<div class="container">
		<div class="search-container flex flex-between" ref="tableHeight">
			<div class="flex flex-wrap">
				<el-date-picker  class="w225" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small" v-model="planDate" @change="handleSearch()"
					type="daterange" range-separator="-" :editable="false"  :picker-options="pickerOptions" :clearable="false"  start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
					<el-select v-model="searchFrom.ncChannel" class="w190 ml10" size="small" placeholder="渠道" @change="handleSearch()"
					clearable>
					<el-option v-for="item in ncChannelList" :key="item.codesetId" :label="item.itemName" :value="item.itemCode">
					</el-option>
				</el-select>
					<el-select v-model="searchFrom.specialChannel" class="w190 ml10" size="small" placeholder="特渠" @change="handleSearch()"
					clearable>
					<el-option v-for="item1 in spChannelList" :key="item1.codesetId" :label="item1.itemName" :value="item1.itemCode">
					</el-option>
				</el-select>
				<el-input v-model.trim="searchFrom.agentName" class="w190 ml10" size="small" placeholder="客商" @keyup.enter.native="handleSearch"
					maxlength="16" clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.agentTag" class="w190 ml10" size="small" placeholder="客商标签" @keyup.enter.native="handleSearch"
					maxlength="16" clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.ncSerial" class="w190 ml10" size="small" placeholder="系列名" @keyup.enter.native="handleSearch"
					maxlength="16" clearable>
				</el-input>
				<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch()" alt="">
			</div>

		</div>
		<div class="table-container" style="width: 100%;">
			<div style="width: 100%;" v-if="tableData.length>0">
				<el-table ref="multipleTable" class="mgrTable"
				    :data="tableData" :height="height"
					:row-class-name="tabRowClassName"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
					:row-key="(row) => { return row.agentId}" @selection-change="handleSelectionChange" border
					style="width: 100%;">
					<el-table-column prop="ncChannel" label="渠道" width="120" :show-overflow-tooltip="true" sortable></el-table-column>
					<el-table-column prop="specialChannel" label="特渠" width="120" sortable ></el-table-column>
					<el-table-column prop="ncSerial" label="系列名" width="150" :show-overflow-tooltip="true" sortable></el-table-column>
					<el-table-column prop="agentName" label="客商" width="150" :show-overflow-tooltip="true" sortable fixed></el-table-column>
					<el-table-column prop="settlementType" label="收款类型" width="120" sortable></el-table-column>
					<el-table-column prop="routeName" label="配送路线" width="150" :show-overflow-tooltip="true" sortable fixed></el-table-column>
					<el-table-column prop="agentTag1" label="销售据点分类" width="120" sortable></el-table-column>
					<!-- <el-table-column prop="agentTag2" label="客商标签2" width="120" sortable></el-table-column> -->
					<el-table-column prop="agentTag3" label="客商标签3" width="120" sortable></el-table-column>
					<el-table-column prop="weekName" label="配送周期" width="200" :show-overflow-tooltip="true" sortable></el-table-column>
					<el-table-column prop="skuNames" label="销售范围" width="120" sortable></el-table-column>
					<el-table-column prop="status" label="店铺状态" width="120" sortable></el-table-column>
					<el-table-column prop="allSale" label="总销量" width="120" ></el-table-column>
					<el-table-column v-show="tableData" v-for="(value,index) in title" :key="index"
						:show-overflow-tooltip="true" :label="value.planDate">
					<el-table-column v-show="tableData" v-for="(item,key) in value.details" :key="key"
						:show-overflow-tooltip="true" :label="item" :width="100">
							<template slot-scope="scope">
								{{scope.row.contents[value.keys[key]]||''}}
							</template>
						</el-table-column>
					</el-table-column>
				</el-table>
			</div>
			<el-empty v-else :style="{height:height+'px'}" description="暂无数据"></el-empty>
			<div class="flex flex-between search-container1">
					<div class="totalPage">
						当前第<span class="page-active">{{currentNo}}</span>页，共<span class="page-active">{{totalCount}}</span>条数据，共<span class="page-active">{{totalPage}}</span>页
					</div>
				<div class="flex">
					<el-pagination
					background
					:current-page="pageNo"
					:page-size="pageSize"
					layout="prev, pager, next"
					@current-change="handleCurrentPage"
					:total="total">
					</el-pagination>
					<img class="icon-img" style="vertical-align: middle;" src="@/assets/images/down.png"
						@click="download" title="导出" alt="">
						</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { hasPermission } from '@/utils/permission'
	import {
		debounce
	} from '@/utils/debounce'
	import {dateFormat} from '@/utils/common'
	import {dateTimeFormat} from '@/utils/common'
	export default {
		name:'merchantAccount',
		components: {
		},
		data() {
			return {
				searchFrom: {
					agentName: "",
					ncChannel:"",
					specialChannel:"",
					ncSerial:"",
					agentTag:"",

				},
				tableData: [],
				titles: [],
				treeData: [],
				multipleSelection: [],
				value: "",
				selectAttribute: "",
				totalPage:"",
				totalCount:"",
				currentNo:"",
				pageNo: 1,
				pageSize: 25,
				height: 0,
				total:0,
				titles: [],
				planDate: [],
				 min: '',
				pickerOptions: {
					onPick: ({minDate, maxDate}) => {
						this.min = minDate && minDate.getTime() // 将第一个选中的日期赋值给 this.min
						// 如果选择了时间段，则清空 this.min
						if(maxDate){
							this.min = ''
						}
					},
					disabledDate: (time) => {
						let oneMonths = 30*24*60*60*1000
						let minDate = this.min - oneMonths
						let maxDate = this.min + oneMonths
						if (this.min !== ""){
							return  time.getTime() > maxDate || time.getTime() < minDate
						}
					}
				},
				options: [
					{
						value: '0',
						label: '未开始'
					}, {
						value: '1',
						label: '已出车'
					}, {
						value: '2',
						label: '已回库'
					}, {
						value: '3',
						label: '已确认'
					}
				],
				ncChannelList:[],
				spChannelList:[],
				title:[],
			}
		},
		created() {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
			this.planDate=[dateFormat(start), dateFormat(end)]
			this.dateFormat = dateFormat
			this.dateTimeFormat = dateTimeFormat
			this.getAgentSaleSearch()
			this.getList()

		},
		mounted() {
			let height = this.$refs.tableHeight.offsetHeight;
			this.height = window.innerHeight - 126 - height;
		},
		methods: {
			tabRowClassName({
				row,
				rowIndex
			}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getList('scroll');
			}, 100, true),

			handleCurrentPage(val){
				this.pageNo = val
				this.getList()

			},

			// 搜索
			handleSearch() {
				this.pageNo = 1
				this.$nextTick(() => {
					this.getList()
				})
			  if (this.tableData.length > 0) {
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}

			},
			getAgentSaleSearch(){
				let that = this;
				that.$request.post(
						"agentSaleSearch",
						true, {}
					)
					.then((res) => {
						that.ncChannelList=res.data.ncChannelList
						that.spChannelList=res.data.spChannelList
					})
			},
			// 获取列表
			getList() {
				let that = this;
				that.$request.post(
						"agentSaleList",
						true, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							dateStart: that.planDate?that.planDate[0]:"",
							dateEnd: that.planDate?that.planDate[1]:"",
							agentName: that.searchFrom.agentName,
							specialChannel: that.searchFrom.specialChannel,
							ncChannel: that.searchFrom.ncChannel,
							ncSerial: that.searchFrom.ncSerial,
							agentTag: that.searchFrom.agentTag,
						}
					)
					.then((res) => {
							if (res.data && res.data.tableDatas.length > 0) {
								that.title = res.data.title
								that.titles = res.data.titles
								that.tableData = res.data.tableDatas
								that.total = res.data.totalCount
								that.totalPage=res.data.totalPage
								that.totalCount=res.data.totalCount
								that.currentNo = res.data.pageNo
							} else {
								that.title = []
								that.titles = []
								that.tableData = []
								that.total=0
								that.totalPage=0
								that.totalCount=0
								that.currentNo = 0
							}
							if(that.tableData.length>0){
									that.$nextTick(() => {
										that.$refs.multipleTable.doLayout(); // 解决表格错位
									});

							}
					})
			},


			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 导出
			download() {
				let that = this;
				that.$request.post(
						"agentSaleExport",
						true, {
							pageNo: 1,
							pageSize: 50000,
							dateStart: that.planDate?that.planDate[0]:"",
							dateEnd: that.planDate?that.planDate[1]:"",
							agentName: that.searchFrom.agentName,
							specialChannel: that.searchFrom.specialChannel,
							ncChannel: that.searchFrom.ncChannel,
							ncSerial: that.searchFrom.ncSerial,
							agentTag: that.searchFrom.agentTag,
						}
					)
					.then((res) => {
						if (res) {
							let downloadURL = res.data
							const linkNode = document.createElement('a');
							linkNode.style.display = 'none';
							linkNode.href = downloadURL;
							document.body.appendChild(linkNode);
							linkNode.click(); //模拟在按钮上的一次鼠标单击
							URL.revokeObjectURL(linkNode.href); // 释放URL 对象
							document.body.removeChild(linkNode);
						}
					})
			},
			//

		},
	}

</script>

<style lang='scss' scoped>
	.container {
		background: #fff;
		box-sizing: border-box;
		margin: 12px 26px 15px 10px;
		// padding-bottom: 20px;

		.el-table {
			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 5px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			 /deep/ .el-table__body-wrapper {
				height:calc(100% - 68px)  !important;
			}

		}

	}
	.red {
		width: 50px;
		height: 20px;
		background: #D9001B;
	}

	.blue {
		width: 50px;
		height: 20px;
		background: #02A7F0;
	}

	.search-container {
		padding: 8px;
	}

	.operation-box {
		min-width: 185px;
	}

	.w190 {
		width: 150px !important;
	}
	.search-container1 {
		padding: 8px;
		// justify-content:flex-end;
		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #1bc9b5;
			color: #FFF !important;
		}
		/deep/  .el-pager li:hover {
			color: #1bc9b5 !important;
		}
	}
.w225{
	width: 240px;
}
</style>
